function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Footer component
 * 
 */
import * as React from 'react';
import ErrorApi from '../../../components/error-api/ErrorApi';
import OrderExpirationModal from '../../../components/order-expiration-modal/OrderExpirationModal';
import Modal from '../../../components/modal/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { deleteAll } from '../../../actions/';
import { isOrderExpired } from '../../../functions/orderExpiration';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Fn } from '../../../functions/Functions';
import { API, OPTIONS, POSTAGE } from '../../../data/Data';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class Footer extends React.Component {
  constructor(props) {
    super(props);
    /**
     * handleKeydown
     */
    _defineProperty(this, "handleKeydown", e => {
      // $FlowFixMe
      const {
        key
      } = e;
      const {
        focus
      } = this.state;
      if (focus && (key === ' ' || key === 'Enter')) {
        this.submit();
      }
    });
    /**
     * onFocus
     */
    _defineProperty(this, "onFocus", () => {
      this.setState({
        focus: true
      });
    });
    /**
     * onBlur
     */
    _defineProperty(this, "onBlur", () => {
      this.setState({
        focus: false
      });
    });
    /**
     * submit
     */
    _defineProperty(this, "submit", () => {
      const {
        canPay,
        application
      } = this.props;
      if (!canPay) {
        return;
      }

      // Check if order has expired before proceeding (modal will already be shown)
      if (application?.created_at && isOrderExpired(application.created_at)) {
        return;
      }
      const data = Fn.formatData(this.props);
      const options = {
        ...OPTIONS,
        method: 'PUT',
        body: JSON.stringify(data)
      };
      const url = `${API}/${application.id}`;
      this.setState({
        submitting: true,
        spinner: true
      });
      fetch(url, options).then(response => {
        if (response.status >= 400) {
          const message = `HTTP status code: ${response.status}`;
          const err = new Error(message);
          response.json().then(result => console.warn(result));
          throw err;
        } else {
          return response.json();
        }
      }).then(result => this.success(result)).catch(err => this.error(err));
    });
    /**
     * success posting to API
     */
    _defineProperty(this, "success", result => {
      const {
        jest
      } = this.props;
      if (result?.data?.order_status && result?.data?.order_status !== 'Pending') {
        this.cancelAndRedirect();
      }

      // handle API validation errors
      if (result.errors || result.message === 'Server Error') {
        this.validationError(result);
      } else {
        this.setState({
          modal: true
        });

        // scroll to top
        if (!jest) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      }
    });
    /**
     * Go to Payment page
     */
    _defineProperty(this, "next", e => {
      e.preventDefault();
      this.setState({
        next: true
      });
    });
    /**
     * API validation error(s)
     */
    _defineProperty(this, "validationError", result => {
      this.setState({
        apiError: true,
        apiErrorMessage: result.message,
        spinner: false
      });
      const msg = `API error${result.message ? ` ${result.message}` : ''}${result.errors ? ` Error(s): ${JSON.stringify(result.errors)}` : ''}`;
      const error = new Error(msg);
      this.error(error);
    });
    /**
     * Error
     */
    _defineProperty(this, "error", err => {
      const {
        application,
        bugsnagClient,
        jest
      } = this.props;
      if (jest) return null;
      console.warn(err);
      err.message = `${err.message}; Application id: ${application.id}`;
      bugsnagClient.notify(err);
    });
    /**
     * Cancel application and redirect
     */
    _defineProperty(this, "cancelAndRedirect", () => {
      const {
        application
      } = this.props;
      deleteAll();
      window.location = application.referrer;
    });
    this.state = {
      apiError: false,
      apiErrorMessage: '',
      focus: false,
      modal: false,
      next: false,
      spinner: false,
      submitting: false
    };
  }
  componentDidMount() {
    // $FlowFixMe
    document.addEventListener('keydown', this.handleKeydown);
  }
  componentWillUnmount() {
    // $FlowFixMe
    document.removeEventListener('keydown', this.handleKeydown);
  }
  render() {
    const {
      application,
      canPay
    } = this.props;
    const {
      apiError,
      modal,
      next,
      spinner
    } = this.state;
    switch (true) {
      case next:
        return /*#__PURE__*/_jsx(Redirect, {
          to: "/payment"
        });
      default:
        return /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(OrderExpirationModal, {}), /*#__PURE__*/_jsx(ErrorApi, {
            apiError: apiError,
            page: "payment"
          }), /*#__PURE__*/_jsx(Modal, {
            name: application.club.abbreviation,
            next: this.next,
            show: modal
          }), /*#__PURE__*/_jsxs("section", {
            className: "footer",
            children: [/*#__PURE__*/_jsxs(Link, {
              className: "button reverse previous",
              to: "/details",
              children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: "chevron-left"
              }), "Previous: Details"]
            }), /*#__PURE__*/_jsxs("div", {
              className: `button next${apiError || !canPay ? ' disabled' : ''}`,
              onClick: () => this.submit(),
              tabIndex: "0",
              role: "button",
              onFocus: this.onFocus,
              onBlur: this.onBlur,
              children: [spinner ? /*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: "spinner",
                spin: true
              }) : /*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: "chevron-right"
              }), "Next: Payment"]
            })]
          })]
        });
    }
  }
}
_defineProperty(Footer, "defaultProps", {
  application: {
    club: {
      abbreviation: 'RACV'
    },
    referrer: 'http://localhost:3000/'
  },
  canPay: false,
  club: {
    autoClub: {
      error: false
    }
  },
  contacts: {
    contactNumber: {
      error: false
    }
  },
  dateOfBirth: {
    error: false
  },
  dateOfTravel: {
    error: false
  },
  deliveryMethod: {
    error: false
  },
  deliveryPickUpStore: {
    error: false
  },
  email: {
    error: false
  },
  jest: false,
  licenceClass: {
    error: false
  },
  licenceExpiry: {
    error: false
  },
  licenceNumber: {
    error: false
  },
  location: {
    search: ''
  },
  names: {
    fullName: {
      error: false
    }
  },
  placeOfBirth: {
    error: false
  },
  postage: {
    ...POSTAGE[0]
  },
  stateOfIssue: {
    error: false
  }
});
const mapStateToProps = ({
  addresses,
  application,
  club,
  confirmEmail,
  cookies,
  deliveryMethod,
  deliveryPickUpStore,
  images,
  licenceClass,
  licenceExpiry,
  licenceNumber,
  contacts,
  dateOfBirth,
  dateOfTravel,
  email,
  marketingConsent,
  names,
  placeOfBirth,
  postage,
  stateOfIssue,
  transaction,
  terms
}) => {
  return {
    addresses,
    application,
    club,
    confirmEmail,
    cookies,
    deliveryMethod,
    deliveryPickUpStore,
    images,
    licenceClass,
    licenceExpiry,
    licenceNumber,
    contacts,
    dateOfBirth,
    dateOfTravel,
    email,
    marketingConsent,
    names,
    placeOfBirth,
    postage,
    stateOfIssue,
    transaction,
    terms
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deleteAll: () => {
      dispatch(deleteAll());
    }
  };
};
const VisibleFooter = connect(mapStateToProps, mapDispatchToProps)(Footer);
export default VisibleFooter;